<template>
    <h2>User Login</h2>
    <form @submit.prevent="login">
        <input v-model="username" type="text" placeholder="用户名" required />
        <input v-model="password" type="password" placeholder="密码" required />
        <button type="submit">登录</button>
    </form>
    <p class="error" v-if="error">{{ error }}</p>
</template>

<script>
    export default {
        data () {
            return {
                username: '',
                password: '',
                error: null
            };
        },
        methods: {
            login () {
                this.$store.dispatch('login', {username: this.username, password: this.password})
                    .catch(error => { //错误信息由状态管理vuex抛出
                        this.error = error;
                    });
            }
        }
    };
</script>

<style>
    .error {
        color: red;
    }
</style>